"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
module.exports = {
  sentry: {
    timeout: false,
    wsEvent: false,
    networkError: true
  },
  apiClient: {
    prefix: 'BACKEND_CLIENT',
    maxRetries: 3
  },
  maxLastFileFeedItems: 6,
  googleApiKey: 'AIzaSyCX4f_qBMrZa-3G5L-HBqENa4iPK25tW8s',
  networkMonitoring: {
    reachability: {
      reachabilityUrls: ['https://clients3.google.com/generate_204', 'https://www.facebook.com', 'https://www.apple.com'],
      reachabilityTest: function () {
        var _reachabilityTest = _asyncToGenerator(function* (response) {
          return response.status === 204;
        });
        function reachabilityTest(_x) {
          return _reachabilityTest.apply(this, arguments);
        }
        return reachabilityTest;
      }(),
      reachabilityLongTimeout: 15000,
      // nominal case
      reachabilityShortTimeout: 5000 // if internet is broken
    },

    wsRTTInterval: 10000,
    downloadFile: 'https://amsignin.com/demo/5M'
  },
  webRTC: {
    maxPeersRequestedConcurrencies: 6,
    videoFailedAttempts: 5,
    defaultRingingDuration: 30000,
    bitrates: {
      enable: true,
      video: 200
    },
    streamMonitoringInterval: 2500,
    streamStatsInterval: 10000,
    // get stats and allow to detect if there is a pb on the stream

    HDEnabled: true
  },
  websocket: {
    reconnect: {
      max: 5000,
      // Infinity, // Number: The max delay before we try to reconnect.
      min: 500,
      // Number: The minimum delay before we try reconnect.
      retries: Infinity,
      // Number: How many times we should try to reconnect.
      factor: 2 // Exponential back off factor
    },

    disconnectAfter: 30000
  },
  reminder: {
    roomDelay: 7200000
  },
  requestLocalStreamAtWsRoomIncoming: true,
  room: {
    backendPingIntervalOnWsDown: 50000,
    displayEndedCallDuration: 5000,
    displayRoomEndIfPersistent: false,
    displayRoomEndIfNoMembersInvited: false,
    autoUnHoldAtRoomEnd: true,
    fetchOnWsReload: true
  },
  session: {
    isGuest: false
  },
  callbacks: {
    maxQueueGeneric: 10,
    maxQueueSpecific: {
      addLog: 30
    }
  },
  feed: {
    reverseFeedItems: false,
    fetchOnWsReload: true
  },
  activity: {
    pageSize: 10,
    fetchOnWsReload: true
  },
  anchor: {
    fetchOnWsReload: true
  },
  sipAccount: {
    fetchOnWsReload: true
  },
  dashboard: {
    fetchOnWsReload: true
  }
};